import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';

@Component({
  selector: 'app-city-offices-search',
  templateUrl: './city-offices-search.component.html',
  styleUrls: ['./city-offices-search.component.scss'],
})
export class CityOfficesSearchComponent implements OnInit {

  /**
   * Summary Initialize Services
   * @param abreCuentasService
   * @param parametersService
   * @param abreCuentasNavigationService
   * @param formBuilder
   */
  constructor(
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
  ) {
  }

  title: string;

  ngOnInit(): void {
    this.title = this.fillSubtitle();
  }

  fillSubtitle() {
    const disbursmentMethod: string = this.abreCuentasService.getOutlaySelection();
    if (!disbursmentMethod) {
      return this.copyService.copies.city_offices_search_title;
    } else if (
      typeof disbursmentMethod === 'string' &&
      disbursmentMethod.includes('cheque')
    ) {
      return this.copyService.copies.outlay_city_search_tittle;
    } else {
      return this.copyService.copies.card_city_search_tittle;
    }
  }

  setAgency(agency: any) {
    console.log('Main Office Code: ', agency.agency_code);
    this.abreCuentasService.setAgencySelected(agency);
  }
}
